import { apiInstance } from '@/modules/core/axios/configs';

export const trackEvent = (data) => {
  return apiInstance.post(`/v1/job-portal/mixpanel/track`, {
    ...data,
  });
};
